import { useAuth } from "Common/Components/Authentication/AuthenticationProvider";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth(); // Obtener el estado de carga y autenticación desde el contexto

  // Mientras el estado de autenticación se está cargando, puedes mostrar un spinner o algún mensaje de espera
  if (loading) {
    return <div>Cargando...</div>;
  }

  // Si el usuario no está autenticado y no está en estado de carga, redirigir a la página de inicio de sesión
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Si está autenticado, renderizar los hijos del componente
  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
